module.exports = __webpack_public_path__ + "resources/img/img_dvision1_en.0893a500ef3d4b62cc9cc33f9d2b4ca4.png";